import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { UtilsService } from 'src/app/services/utils.service';
import { IndividualSimChangeRes, RequestsBulkSwap } from '../../../../common/models/data.model';
import { SIM_CHANGE_CONST, MANAGE_LINE_CONST, COMMON_CONSTANTS, BULK_UPLOAD } from '../../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sim-change-form',
  templateUrl: './sim-change-form.component.html',
  styleUrls: ['./sim-change-form.component.scss']
})
export class SimChangeFormComponent implements OnInit, OnChanges {
  @Input() reasons: any;
  @Input() linesWithError: any;
  @Input() selectedReason: any;
  @Input() bulkSimChange: any;
  @Input() newSimNumber: any;
  @Input() lineIndex: any;
  simCardNumberMessage: any = "";
  confirmSimCardNumberMessage: any = "";
  duplicateSimMessage: any;
  isConfirmSimOn = false;
  reasonForChanges: any;
  simChangeNumber: any = "";
  newSimChangeNumber: any = "";
  changeTriggered:boolean = true;
  submitChange = false;
  removedSimChangeEligibility = false;
  individualSimChangeRes: IndividualSimChangeRes = new IndividualSimChangeRes();
  requestsBulkSwap: RequestsBulkSwap = new RequestsBulkSwap();
  multiSimChangeNextButton: any;
  @Input() finalConfirmation: boolean;
  @Input() lineType: any;
  @Input() msisdn: any;
  @Input() oldSim: any;
  @Output() submitChangeValue = new EventEmitter();
  @Output() submitNextValue = new EventEmitter();
  @Output() eSimBtnClicked = new EventEmitter();
  @Input() multiSimChange;
  @Input() bulkSuccesslines;
  resonErrorInline: any;
  orgId: any;
  authoringContentData: any;
  authInfo: any;
  regex19 = SIM_CHANGE_CONST.REGEX19;
  regex20 = SIM_CHANGE_CONST.REGEX20;
  regex31 = SIM_CHANGE_CONST.REGEX31;
  regex32 = SIM_CHANGE_CONST.REGEX32;
  regex15 = SIM_CHANGE_CONST.REGEX15;
  removedReasonCode = SIM_CHANGE_CONST.REMOVED_REASON_CODE;
  request: any = {};  
  esimEnabled: boolean = environment.ENABLE_ESIM;
  enterValueTxt: any;
  confirmText: any;
  maxLengthofField: number;
  eSim: boolean;
  multiMsisdn: any;
  clickEsim: boolean = false;
  clickPsim: boolean = false;
  eidNumber: string;
  eidMessage: string;
  logonID: any;
  logonEmail: any;
  isCollapsed: boolean;
  emptyEIDreturned: boolean= false;
  loaderVisible: boolean = false;
  eSimChangeSupported: any;
  eSimEligible: boolean;
  modelName: any;
  unknownEid: string = '';
  disableNextForMulti: boolean = false;
  incompatibleEid: any;
  validEid: boolean = false;
  notCompatibleTxt: any;
  ngbModalOptions:NgbModalOptions;
  checkedRadioButton: any;
  disableEID: boolean = true;
  @ViewChild('warningModal') warningModal: ElementRef;
  compatibleEid: any;
  disableEIDEntry: boolean= false;

  constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService, 
    private _cacheSvc: HttpCacheService, private helperUtility: HelperUtilityService,
    private _loaderSvc: LoaderService,private modalService: NgbModal) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeSim;
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this.isCollapsed = true;
    this.checkedRadioButton = SIM_CHANGE_CONST.ESIM;
    this.checkEsimEligibility();
    this.orgId = !isNullOrUndefined(this.helperUtility.getOrgID()) ? this.helperUtility.getOrgID() : '';
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    this.logonEmail = this.utilsSvc.isNotNullOrUndefined(this.authInfo?.logonEmail) ? this.authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
    this.logonID = this.utilsSvc.isNotNullOrUndefined(this.authInfo?.logonID) ? this.authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
    this.getSimChangeEligibility(this.msisdn || '', this.simChangeNumber || '');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isNullOrUndefined(this.reasons)) {
      if (this.bulkSimChange) {
        const description = this.reasons.map(function (item) {
          return item.description;
        });
        const indexDescription = description.indexOf(this.selectedReason);
        this.reasonForChanges = this.reasons[indexDescription];
        this.assignSimFieldValue();        
        this.individualSimChangeRes.mobileNumber = this.msisdn;
        this.multiSimChangeNextButton = this.individualSimChangeRes;
      } else {
        this.reasonForChanges = this.reasons[this.reasons.length - 1];
      }
    }
  }
  assignSimFieldValue(){
    if(this.esimEnabled 
      && ((this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === "" && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === "") 
      || (this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== "" && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] !== "")
      )){
      this.simChangeNumber = "";
      this.clickEsim = true;
    }else if(this.esimEnabled && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== "" && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === ""){
      this.eidNumber = this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt]; 
      this.clickEsim = true;
      this.eSim = true;
    }else if(this.esimEnabled && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === "" && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === this.multiSimChange[this.lineIndex].OldSim){
      this.simChangeNumber = "";
      this.clickPsim = true;
    }else if(this.esimEnabled && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === "" && this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] !== ""){
      this.simChangeNumber = this.multiSimChange[this.lineIndex][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt];
      this.clickPsim = true;
    }else{
      this.simChangeNumber = this.multiSimChange[this.lineIndex].NewSim;
    }
  }
  checkEsimEligibility(){
    if(this.esimEnabled && !this.bulkSimChange){
      this.clickEsim = true; //single & multi line scenario
    }
    if((this.esimEnabled && this.bulkSimChange && this.clickEsim) || (this.esimEnabled && !this.bulkSimChange)){
      this.eSimClicked(false);
    }else if((this.esimEnabled && this.bulkSimChange && this.clickPsim) || (!this.esimEnabled)){
      this.pSimClicked(false);
    }
  }
  getSimChangeEligibility(msisdn: any, simChangeNumber: any) {
    if(this.esimEnabled && this.eSim && !this.bulkSimChange){
      this.eidNumber = '';
      this.disableSubmitBtn(msisdn);
    }
    if (this.utilsSvc.isNotNullOrUndefined(simChangeNumber) && simChangeNumber !== '' && this.utilsSvc.isNotNullOrUndefined(this.bulkSimChange)) {
      if ((!this.eSim && (this.regex19.test(simChangeNumber) || this.regex20.test(simChangeNumber))) || (this.eSim && this.regex15.test(simChangeNumber))) {
        /* 
        * 1st condition: esim false(physical SIM radio button selected) and regex for sim validation
        * 2nd condition: esim true(eSIM radio button selected) and regex15 rule for IMEI
        */
        this.checkOldAndNewSimNumber(simChangeNumber, msisdn);
      } else {
        this.simChangeIsInvalid();       
      }

    } else if (this.utilsSvc.isNotNullOrUndefined(simChangeNumber) && simChangeNumber !== '' && isNullOrUndefined(this.bulkSimChange)) {
      this.emptyEIDreturned = false;
      this.getSimChangeEligibilityCheck(msisdn, simChangeNumber);
    }

  }
  checkOldAndNewSimNumber(simChangeNumber, msisdn){
    if (!isNullOrUndefined(simChangeNumber) && this.oldSim === this.simChangeNumber) {
      this.duplicateSimMessage = SIM_CHANGE_CONST.DUPLICATE_SIM;
    } else {
      this.getSimChangeEligibilityCheck(msisdn, simChangeNumber);
    }
  }
  
  getSimChangeEligibilityCheck(msisdn: any, simChangeNumber: any) {
    if (!isNullOrUndefined(simChangeNumber)) {
      if (!isNullOrUndefined(this.bulkSimChange) && this.bulkSimChange  &&  !isNullOrUndefined(this.bulkSuccesslines)) {
        this.removedMultiSimChangeCall(simChangeNumber, this.bulkSuccesslines);
      } else if (!isNullOrUndefined(this.multiSimChange)) {
        this.removedMultiSimChangeCall(simChangeNumber, this.multiSimChange);
      }
    }
    if (!this.removedSimChangeEligibility) {
      if (this.utilsSvc.isNotNullOrUndefined(msisdn) && this.utilsSvc.isNotNullOrUndefined(simChangeNumber)&& !(this.eSim) && (this.regex19.test(simChangeNumber) || this.regex20.test(simChangeNumber))) {
        this.createSimChangeRequest(msisdn, simChangeNumber);
      }
      else if(this.utilsSvc.isNotNullOrUndefined(msisdn) && this.utilsSvc.isNotNullOrUndefined(simChangeNumber)&& this.eSim && this.regex15.test(simChangeNumber)) {
        this.simCardNumberMessage = '';
        this.createSimChangeRequest(msisdn, simChangeNumber);
      }
       else if (simChangeNumber === '') {
        this.simCardNumberMessage = '';
        this.disableEID = true;
        this.confirmNewSimChangeNumner(this.newSimChangeNumber, this.simChangeNumber);
      } else {
        this.simChangeIsInvalid();
      }
    }
  }
  eidChangeIsInvalid(){
    this.eidMessage = SIM_CHANGE_CONST.EID_INVALID;
    this.clearConfirmField(SIM_CHANGE_CONST.ESIM);
    this.changeTriggered = true;
    this.submitChange = false;
  }

  simChangeIsInvalid(){    
    this.setSimCardNumberMsg();
    this.clearConfirmField(SIM_CHANGE_CONST.NEW_SIM);
    this.changeTriggered = true;
    this.submitChange = false;
    this.disableEID = true;
  }
  checkEidReturnedFromApi(simChangeEligibilityReasons){
    this.emptyEIDreturned = false;
    this.eidNumber = simChangeEligibilityReasons.eid;
    if(this.eidNumber == null){
      this.emptyEIDreturned = true;
      if(this.eSimChangeSupported.toUpperCase() == SIM_CHANGE_CONST.UNKNOWN){
        this.disableEID = false;
      }
    }
    if(this.eidNumber !== null && this.eSimChangeSupported.toUpperCase() == SIM_CHANGE_CONST.UNKNOWN){
	  this.emptyEIDreturned = true;
      this.disableEID = false;
      this.unknownEid = simChangeEligibilityReasons.eid;
      this.eidNumber = '';
    }
    if(this.eidNumber !== null && this.eSimChangeSupported == MANAGE_LINE_CONST.N_CTA){
      this.incompatibleEid = simChangeEligibilityReasons.eid;
    }
    if(this.eidNumber !== null && this.eSimChangeSupported == MANAGE_LINE_CONST.Y_CTA){
      this.compatibleEid = simChangeEligibilityReasons.eid;
    }
    if((this.utilsSvc.isNotNullOrUndefined(this.compatibleEid) && this.compatibleEid!=='')||(this.utilsSvc.isNotNullOrUndefined(this.incompatibleEid) && this.incompatibleEid!=='')){
      this.disableEIDEntry = true;
    }
  }
  checkEsimSupported(){
    if(this.eSimChangeSupported == MANAGE_LINE_CONST.Y_CTA){
      this.eSimEligible = true;
    }else if(this.eSimChangeSupported == MANAGE_LINE_CONST.N_CTA || this.eSimChangeSupported.toUpperCase() == SIM_CHANGE_CONST.UNKNOWN){
      this.eSimEligible = false;
    }
  }
  setEIDSupportedMessages(){
    if(!this.emptyEIDreturned && this.esimEnabled && this.eSim){
      if(!this.eSimEligible && this.eSimChangeSupported.toUpperCase() == SIM_CHANGE_CONST.UNKNOWN){
        this.eidMessage = '';
      }
      if(this.eSimEligible){
        this.eidMessage = SIM_CHANGE_CONST.SUCCESS_EID_TXT + this.modelName +SIM_CHANGE_CONST.EID_SUPPORTED;
      }
      if(!this.eSimEligible && this.eSimChangeSupported == MANAGE_LINE_CONST.N_CTA){
        this.notCompatibleTxt = (this.modelName ? this.modelName : SIM_CHANGE_CONST.PHONE) + SIM_CHANGE_CONST.PHONE_NOT_COMPATIBLE;
        this.eidMessage = this.notCompatibleTxt;
        this.submitChangeValue.emit(null);
        this.requestsBulkSwap.eid = '';
        this.submitNextValue.emit(this.requestsBulkSwap);
      }
    }
  }
  startLoader(){
    if(this.esimEnabled){
      this.loaderVisible = true;
    }else{
      this._loaderSvc.start();
    }
  }
  stopLoader(){
    if(this.esimEnabled){
      this.loaderVisible = false;
    }else{
      this._loaderSvc.stop();
    }
  }
  createParamForEligibilityAPI(simChangeNumber){
    if(this.esimEnabled && this.eSim){
      delete this.request['newSim']
      this.request.imei = this.utilsSvc.isNotNullOrUndefined(simChangeNumber) ? simChangeNumber : '';
    }else{
      delete this.request['imei']
      this.request.newSim = this.utilsSvc.isNotNullOrUndefined(simChangeNumber) ? simChangeNumber : '';
    }  
  }
  createSimChangeRequest(msisdn, simChangeNumber){
    this.request.mobileNumber = !isNullOrUndefined(msisdn) ? msisdn : '';
    this.createParamForEligibilityAPI(simChangeNumber) 
        this.startLoader();
        this.manageLineService.simChangeEligibility(this.request).subscribe(simChangeEligibilityReasons => {
          this.stopLoader();
          if(this.esimEnabled &&  this.eSim){
            this.disableEID = true;
            this.validEid = false;
            this.unknownEid = '';
            this.modelName = '';
            this.incompatibleEid = '';
            this.eSimChangeSupported = this.utilsSvc.isNotNullOrUndefined(simChangeEligibilityReasons.eSimSupported) ? simChangeEligibilityReasons.eSimSupported : SIM_CHANGE_CONST.UNKNOWN;
            this.checkEidReturnedFromApi(simChangeEligibilityReasons);
            this.modelName = this.utilsSvc.isNotNullOrUndefined(simChangeEligibilityReasons.model) ? simChangeEligibilityReasons.model : '';
            const oldSim = this.utilsSvc.isNotNullOrUndefined(simChangeEligibilityReasons.oldSim) ? simChangeEligibilityReasons.oldSim : '';
            this.multiSimChangeNextButton = simChangeEligibilityReasons;
            this.oldSim = oldSim;
            this.checkEsimSupported();
            this.enableSubmitforEID(simChangeEligibilityReasons.msisdn,this.eidNumber,oldSim);
            this.setEIDSupportedMessages();
          }else{
            this.populateSimChangeEligibilityResponse(simChangeEligibilityReasons);
          }
        }, err => {
          this.stopLoader();
          this.simCardNumberMessage = "";
          this.removeSimChangerError(err,true);
          this.confirmNewSimChangeNumner(this.newSimChangeNumber, this.simChangeNumber);
          this.setErrorValuesforEID();
        });
  }

  setErrorValuesforEID(){
    if(this.esimEnabled &&  this.eSim){
      this.eidNumber = '';
      this.eidMessage = '';
      this.requestsBulkSwap.eid = '';
      this.submitNextValue.emit(this.requestsBulkSwap);
      this.submitChangeValue.emit(null);
      this.submitChange = false;
     }
  }
  clearConfirmField(field){         
    if(field === SIM_CHANGE_CONST.NEW_SIM){
      if(this.newSimChangeNumber !== ""){
        this.newSimChangeNumber = "";
        this.confirmSimCardNumberMessage = "";
        this.changeTriggered = true;
      } 
      if(!(this.esimEnabled && this.eSim)){
        this.submitNextValue.emit(null);
        this.submitChangeValue.emit(null);
        this.newSimNumberisDifferent(this.newSimChangeNumber, this.simChangeNumber);
      }
      this.checkIfImeiValid();
    }else if(field === SIM_CHANGE_CONST.CONFIRM_SIM){
      if(this.newSimChangeNumber !== this.simChangeNumber){
      this.submitNextValue.emit(null);
      this.submitChangeValue.emit(null);
      this.newSimNumberisDifferent(this.newSimChangeNumber, this.simChangeNumber);
      }
    }
    else if(field === SIM_CHANGE_CONST.ESIM){
      if (!(this.utilsSvc.isNotNullOrUndefined(this.eidNumber) && (this.regex31.test(this.eidNumber) || this.regex32.test(this.eidNumber)))) {
        this.submitChangeValue.emit(null);
          this.requestsBulkSwap.eid = '';
        this.submitNextValue.emit(this.requestsBulkSwap);
      }  
    }  
  }
  checkIfImeiValid() {
    if(this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) && this.simChangeNumber.length < SIM_CHANGE_CONST.IMEI_LENGTH && this.esimEnabled && this.eSim){
      this.disableEID = true;
      this.setErrorValuesforEID();
      this.emptyEIDreturned = false;
      this.disableEIDEntry = false;
    }
  }

  removeSimChangerError(err,bulkFailure?){
    if (!this.lineType) {
      this.simChangeError(err);
    } else {
      this.setSimCardNumberMsg(bulkFailure);
    }
  }

  populateSimChangeEligibilityResponse(simChangeEligibilityReasons){
    if (!isNullOrUndefined(simChangeEligibilityReasons)) {
      if (!this.lineType) {
        this.individualSimChangeRes.ban = !isNullOrUndefined(simChangeEligibilityReasons.ban) ? simChangeEligibilityReasons.ban : '';
        this.individualSimChangeRes.oldSim =
          !isNullOrUndefined(simChangeEligibilityReasons.oldSim) ? simChangeEligibilityReasons.oldSim : '';
        this.individualSimChangeRes.mobileNumber =
          !isNullOrUndefined(simChangeEligibilityReasons.msisdn) ? simChangeEligibilityReasons.msisdn : '';
      } else {
        this.multiSimChangeNextButton = simChangeEligibilityReasons;
      }
      this.checkSimEligibilityStatusAsSuccess(simChangeEligibilityReasons);
    }
  }

  checkSimEligibilityStatusAsSuccess(simChangeEligibilityReasons){
    if (simChangeEligibilityReasons.status === SIM_CHANGE_CONST.SUCCESS) {
      this.simCardNumberMessage = SIM_CHANGE_CONST.SIM_NUMBER_VALID;
      this.changeTriggered = false;  
    } else {
      this.changeTriggered = true;  
      this.simCardNumberMessage = simChangeEligibilityReasons?.validationErrors ?
        simChangeEligibilityReasons.validationErrors[COMMON_CONSTANTS.DIGITS.ZERO] : '';
      this.clearConfirmField(SIM_CHANGE_CONST.NEW_SIM);
      this.submitChange = false;
    }
  }

  removedMultiSimChangeCall(simChangeNumber, multiSimChange) {
    this.removedSimChangeEligibility = false;
    if (!isNullOrUndefined(multiSimChange)) {
      for(let simChange of multiSimChange) {
        if ((simChange !== null || simChange !== undefined) &&
          (simChangeNumber === simChange?.newSim || simChangeNumber === simChange?.NewSim)) {
          this.removedSimChangeEligibility = true;
          this.simCardNumberMessage = SIM_CHANGE_CONST.SIM_NUMBER_EXIST;
          this.clearConfirmField(SIM_CHANGE_CONST.NEW_SIM);
          this.submitChange = false;
        }
      }
    }
  }

  disableSubmitBtn(msisdn){
    this.submitChange = false;
    this.submitChangeValue.emit(null);
    this.createMultiRequestBody('',msisdn);
    this.disableNextForMulti = true;
  }

  createRequest(msisdn,eidNumber,oldSim){
    if(!(this.disableNextForMulti)){
      if(!this.lineType){
        this.msisdn = msisdn;
        this.createSingleLineRequestBody(oldSim,eidNumber);
      }
      else{
        this.createMultiRequestBody(eidNumber,msisdn);
      }
    }
  }

  setNotCompatibleMsg(){
    if(this.eSimChangeSupported == MANAGE_LINE_CONST.N_CTA){
      this.notCompatibleTxt = (this.modelName ? this.modelName : SIM_CHANGE_CONST.PHONE) + SIM_CHANGE_CONST.PHONE_NOT_COMPATIBLE;
        this.eidMessage = this.notCompatibleTxt;
    }
  }

  checkIfEidSupported(eidNumber,msisdn){
    // when eSimSupported flag value is 'Unknown' , allow the user to submit only the EID returned from the eligibility API.
    if(eidNumber !== this.unknownEid && this.utilsSvc.isNotNullOrUndefined(this.unknownEid) && this.unknownEid !== ''){
      this.eidMessage = SIM_CHANGE_CONST.VERIFY_EID;
      this.disableSubmitBtn(msisdn);
    }
  }

  enableSubmitforEID(msisdn,eidNumber,oldSim?){
    this.disableNextForMulti = false;
    const bulkFlow = this.bulkSimChange && this.utilsSvc.isNotNullOrUndefined(msisdn) && this.utilsSvc.isNotNullOrUndefined(eidNumber) && this.eSim && (this.regex32.test(eidNumber) || this.regex31.test(eidNumber));
    const singleOrMultiFlow = this.utilsSvc.isNotNullOrUndefined(msisdn) && this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) && this.regex15.test(this.simChangeNumber) && this.utilsSvc.isNotNullOrUndefined(eidNumber)&& this.eSim && (this.regex32.test(eidNumber) || this.regex31.test(eidNumber))
    if(singleOrMultiFlow || bulkFlow) {
      this.eidMessage = '';
      this.validEid = true;
      this.checkIfEidSupported(eidNumber,msisdn);
      this.createRequest(msisdn,eidNumber,oldSim);
    }    
    else if(eidNumber == null && this.utilsSvc.isNotNullOrUndefined(oldSim) && !this.lineType){
      this.eidMessage = '';
      this.setNotCompatibleMsg();
      this.msisdn = msisdn;
      this.createSingleLineRequestBody(oldSim,eidNumber);
    }
    else if(eidNumber == null && this.lineType){
      this.eidMessage = '';
      this.setNotCompatibleMsg();
        this.requestsBulkSwap.eid = '';
      this.submitNextValue.emit(this.requestsBulkSwap);
    }
    else if((eidNumber === '' && this.eSimChangeSupported.toUpperCase() == SIM_CHANGE_CONST.UNKNOWN) || eidNumber === ''){
      this.eidMessage = '';
      this.submitChange = false;
      this.submitChangeValue.emit(null);
      this.createMultiRequestBody(eidNumber,msisdn)
    }
    else {
      this.eidChangeIsInvalid();
    }
  }
  createSingleLineRequestBody(oldSim,eidNumber){
    let ban = this._cacheSvc.getFromSessionStorage('ban');
    this.individualSimChangeRes.mobileNumber = this.msisdn;
    this.individualSimChangeRes.ban = ban;
    this.individualSimChangeRes.oldSim = oldSim ? oldSim : '';
    this.individualSimChangeRes.eid = eidNumber;
    this.individualSimChangeRes.reasonCode = this.utilsSvc.isNotNullOrUndefined(this.reasonForChanges?.code) ? this.reasonForChanges.code : '';
    this.individualSimChangeRes.logonId = this.logonID;
    this.individualSimChangeRes.email = this.logonEmail;
    if (this.utilsSvc.isNotNullOrUndefined(eidNumber) && (this.regex31.test(eidNumber) || this.regex32.test(eidNumber))) {
        this.submitChange = true;
        this.submitChangeValue.emit(this.individualSimChangeRes);
    }
    if(eidNumber == null){
      this.submitChange = false;
      this.submitChangeValue.emit(null);
      this.submitNextValue.emit(null);
    }
  }
  createMultiRequestBody(eidNumber,msisdn){
    if((this.bulkSimChange && this.utilsSvc.isNotNullOrUndefined(this.reasonForChanges) && this.utilsSvc.isNotNullOrUndefined(this.reasonForChanges?.code) 
    && this.reasonForChanges?.code !== '') || !this.bulkSimChange){
      this.requestsBulkSwap.orgId = this.orgId;
      this.requestsBulkSwap.logonId = this.logonID;
      this.requestsBulkSwap.email = this.logonEmail;
      this.requestsBulkSwap.eid = eidNumber;
      this.requestsBulkSwap.reasonCode = this.utilsSvc.isNotNullOrUndefined(this.reasonForChanges) && this.utilsSvc.isNotNullOrUndefined(this.reasonForChanges.code) ? this.reasonForChanges.code : '';
      this.requestsBulkSwap.msisdn = msisdn;
      this.submitNextValue.emit(this.requestsBulkSwap);
    }
  }
  confirmNewSimChangeNumner(newSimChangeNumber: any, simChangeNumber: any) {
    if (simChangeNumber && newSimChangeNumber) {
      if (newSimChangeNumber === simChangeNumber) {
        this.submitChange = true;
          this.confirmSimCardNumberMessage = SIM_CHANGE_CONST.CONFIRM_SIM_NUMBER_MATCHES;
        this.getSimChangeReasonValue(this.reasonForChanges);
        this.submitNextValue.emit(this.requestsBulkSwap);
      } else {
        this.submitChange = false;
          this.confirmSimCardNumberMessage = SIM_CHANGE_CONST.CONFIRM_SIM_NUMBER_NOT_MATCHES;
        this.newSimNumberisDifferent(newSimChangeNumber, simChangeNumber);
        this.submitChangeValue.emit(null);
       }
    }
  }
  newSimNumberisDifferent(newSimChangeNumber, simChangeNumber){
    if (!isNullOrUndefined(this.reasonForChanges) && this.lineType) {
      this.requestsBulkSwap.newSim = (newSimChangeNumber.length <= simChangeNumber.length) ?
        newSimChangeNumber.slice(COMMON_CONSTANTS.DIGITS.ZERO, newSimChangeNumber.length - COMMON_CONSTANTS.DIGITS.THREE)
        : simChangeNumber.slice(COMMON_CONSTANTS.DIGITS.ZERO, simChangeNumber.length - COMMON_CONSTANTS.DIGITS.THREE);
      this.submitNextValue.emit(this.requestsBulkSwap);
    }
  }
  getSubmitChange(eidNumber){
    if(this.esimEnabled && (this.lineType || this.bulkSimChange) && this.utilsSvc.isNotNullOrUndefined(eidNumber) && eidNumber !== "" && !this.disableNextForMulti){
      this.submitChange = true;
    }
    if(this.esimEnabled && eidNumber == this.incompatibleEid && this.utilsSvc.isNotNullOrUndefined(this.incompatibleEid)){
      this.submitChange = false;
    }
  }
  getSimChangeReasonValue(reasonForChanges: any, eidNumber?, msisdn?) {
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    if (reasonForChanges) {
      this.reasonForChanges = reasonForChanges;
      if(eidNumber){
        this.getSubmitChange(eidNumber);
      }
      if (reasonForChanges?.code && this.submitChange) {
        if (!this.lineType) {
          this.getIndividualSimChangeRequest(eidNumber,reasonForChanges);
        } else {
          this.createMultiOrBulkReqBody(msisdn,eidNumber,reasonForChanges);
        }
      } else {
        this.submitNextValue.emit(null);
        this.submitChangeValue.emit(null);
      }
    }
  }

  getIndividualSimChangeRequest(eidNumber,reasonForChanges){
    if(this.esimEnabled && this.eSim){
      this.individualSimChangeRes.eid = this.utilsSvc.isNotNullOrUndefined(eidNumber) ? eidNumber : '';
    }
    else{
      this.individualSimChangeRes.newSim = this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) ? this.simChangeNumber : '';
    }
    this.individualSimChangeRes.reasonCode = this.utilsSvc.isNotNullOrUndefined(reasonForChanges?.code) ? reasonForChanges.code : '';
    this.individualSimChangeRes.logonId = this.logonID;
    this.individualSimChangeRes.email = this.logonEmail;
    this.submitChangeValue.emit(this.individualSimChangeRes);

  }

  createMultiOrBulkReqBody(msisdn,eidNumber,reasonForChanges){
    this.requestsBulkSwap.orgId = this.orgId;
    this.requestsBulkSwap.logonId = this.logonID;
    this.requestsBulkSwap.email = this.logonEmail;
    this.getMsisdnAndNewSim(msisdn,eidNumber);
    this.requestsBulkSwap.reasonCode = this.utilsSvc.isNotNullOrUndefined(reasonForChanges?.code) ? reasonForChanges.code : '';
    this.submitNextValue.emit(this.requestsBulkSwap);
  }

  getMsisdnAndNewSim(msisdn,eidNumber){
    if(this.esimEnabled && this.eSim){
      this.requestsBulkSwap.eid = this.utilsSvc.isNotNullOrUndefined(eidNumber) ? eidNumber : '';
    }else{
      this.requestsBulkSwap.newSim = this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) ? this.simChangeNumber : '';
    }
    if(this.utilsSvc.isNotNullOrUndefined(msisdn)){
      this.requestsBulkSwap.msisdn = msisdn;
    }else if(this.utilsSvc.isNotNullOrUndefined(this.multiSimChangeNextButton.msisdn)){
      this.requestsBulkSwap.msisdn = this.multiSimChangeNextButton.msisdn;
    }else if(this.utilsSvc.isNotNullOrUndefined(this.multiSimChangeNextButton.mobileNumber)){
      this.requestsBulkSwap.msisdn = this.multiSimChangeNextButton.mobileNumber;
    }else{
      this.requestsBulkSwap.msisdn = '';
    }
  }
  simChangeError(error): void {
    this.utilsSvc.errorHandling(error);
  }

  getVariableValue(val: any) {
    if (isNullOrUndefined(val)) {
      return true;
    } else {
      return false;
    }
  }
   
  eSimClicked(openWarningModal){
    this.checkedRadioButton = SIM_CHANGE_CONST.ESIM;
    this.disableEID = this.bulkSimChange? false : true;
    this.disableEIDEntry=false;
    if(openWarningModal && this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) && this.simChangeNumber.length >0){
      this.modalService.open(this.warningModal,this.ngbModalOptions);
    }else{
      this.setEsimValues();
    }
  }
  pSimClicked(openWarningModal){
    this.checkedRadioButton = SIM_CHANGE_CONST.PSIM;
    if(openWarningModal && ((this.utilsSvc.isNotNullOrUndefined(this.eidNumber) && this.eidNumber.length > 0) || (this.utilsSvc.isNotNullOrUndefined(this.simChangeNumber) && this.simChangeNumber.length >0))){
      this.modalService.open(this.warningModal,this.ngbModalOptions);
    }else{
      this.setPsimValues();
    }
  }
  setEsimValues(){
    this.eSim =true;
    this.enterValueTxt = this.authoringContentData.imeiHeader;
    this.maxLengthofField = SIM_CHANGE_CONST.IMEI_LENGTH;
    this.initialiseValues(this.eSim);
    this.eSimBtnClicked.emit({ esimSelected:true});
  }
  setPsimValues(){
    this.eSim = false;
    this.enterValueTxt = this.authoringContentData.newSimTxt;
    this.maxLengthofField = SIM_CHANGE_CONST.PSIM_LENGTH;
    this.initialiseValues(this.eSim);
    this.eSimBtnClicked.emit({esimSelected:false});
  }
  initialiseValues(eSim){
    if(!this.bulkSimChange || (this.bulkSimChange && this.clickPsim && eSim)){
      /*
      1.To prepopulate excel EID values
      2.On changing radio button option, clearing out current input fields */
     this.simChangeNumber = '';
     this.clickPsim = false;
     this.clickEsim = true;
     this.eidNumber = '';
    }else if(!this.bulkSimChange || (this.bulkSimChange && this.clickEsim && !eSim)){
      /*
       1.To prepopulate excel NewSim values
       2.On changing radio button option, clearing out current input fields */
      this.simChangeNumber = '';
      this.clickEsim = false;
      this.clickPsim = true;
      this.eidNumber = '';
    }    
    this.eidMessage = '';
    this.simCardNumberMessage ='';
    this.newSimChangeNumber = '';
    this.confirmSimCardNumberMessage = '';
    this.changeTriggered = true;
    this.requestsBulkSwap.eid = '';
    this.requestsBulkSwap.newSim = '';
    this.submitChangeValue.emit(null);
    this.submitChange = false;
    this.submitNextValue.emit(this.requestsBulkSwap);
    this.emptyEIDreturned = false;
  } 

  setSimCardNumberMsg(bulkFailure?){
    if(!bulkFailure){
      if(this.eSim && this.esimEnabled){
        this.simCardNumberMessage = SIM_CHANGE_CONST.IMEI_INVALID;
      }
      else{
        this.simCardNumberMessage = SIM_CHANGE_CONST.SIM_NUMBER_INVALID;
      }
    }
  }
  continueBtn(d){
    d(SIM_CHANGE_CONST.DISMISS_MODAL);
    if(this.checkedRadioButton == SIM_CHANGE_CONST.ESIM){
      this.checkedRadioButton = SIM_CHANGE_CONST.ESIM;
      this.setEsimValues();
    }
    else{
      this.checkedRadioButton = SIM_CHANGE_CONST.PSIM;
      this.setPsimValues();
    }
  }
  cancelBtn(d){
    d(SIM_CHANGE_CONST.DISMISS_MODAL);
    if(this.checkedRadioButton == SIM_CHANGE_CONST.ESIM){
      this.checkedRadioButton = SIM_CHANGE_CONST.PSIM;
    }else{
      this.checkedRadioButton = SIM_CHANGE_CONST.ESIM;
    }
  }

}
